export enum SuggestedModuleType {
  RSS_FEED = 'rss_feed',
  VIDEO = 'video',
  WEB_LINK = 'web_link',
}

export enum SuggestedModuleDisplayStyle {
  CARD = 'card',
  LIST = 'list',
  BANNER = 'banner',
}

export enum VideoQuantity {
  SINGLE = 'single',
  MULTIPLE = 'multiple',
}

type Thumbnail = {
  path: string;
  removeCurrentThumbnail?: boolean;
};

export type SuggestedModule = {
  id: string;
  name: string;
  description: string;
  moduleType: SuggestedModuleType | string;
  url: string;
  thumbnailPath: string | null;
  thumbnailUrl: string | null;
  displayStyle: SuggestedModuleDisplayStyle | string;
  isVideoMultiple: boolean;
  startDate: string | null;
  endDate: string | null;
};

export type SuggestedModuleCreateRequest = {
  name: string;
  description: string;
  moduleType: SuggestedModuleType | string;
  url: string;
  displayStyle: SuggestedModuleDisplayStyle | string;
  isVideoMultiple: boolean;
  startDate: string | null;
  endDate: string | null;
  thumbnail: Thumbnail | null;
};

export type SuggestedModuleListResponse = {
  items: SuggestedModule[];
  limit: number;
  total: number;
};

export type DisplayStyleConfig = {
  value: SuggestedModuleDisplayStyle;
  label: string;
  description: string;
  icon: string;
  badge?: string;
  badgeColor?: string;
};

export type SuggestedModuleFormState = Omit<SuggestedModuleCreateRequest, 'thumbnail'> & {
  thumbnailPreview: string | null;
  thumbnailPath: string | null;
};
